<template>
  <dropdown ref="dropdownRef" class="ifp-filter-sort" title="List Options" placement="bottom-end">
    <!-- Tablet/desktop -->
    <base-ifp-filter v-if="$screen.isTabletOrDesktop($mq)" label="Sort" clear-background>
      <template #value-display>{{ selectedSortLabel }}</template>
    </base-ifp-filter>
    <!-- Mobile -->
    <i v-else class="ddi ddi-sort" />
    <template #content>
      <div>
        <ul>
          <li v-if="(showSwitchToList || showSwitchToKanban) && $permissions.isAdminOrOwner" @click="handleSettings">
            <i class="ddi ddi-cog" />
            <span>Settings</span>
          </li>
          <li v-if="showSwitchToKanban" @click="handleSwitchToKanban">
            <i class="ddi ddi-kanban" />
            <span>Switch to Kanban</span>
          </li>
          <li v-else-if="showSwitchToList" @click="handleSwitchToList">
            <i class="ddi ddi-list" />
            <span>Switch to List</span>
          </li>
          <li v-if="showSwitchToKanban || showSwitchToList" class="ifp-filter-sort__divider" />
          <li v-if="showSwitchToKanban || showSwitchToList" class="ifp-filter-sort__section-header">Sort</li>
          <li v-for="sort in sortOptions" :key="sort.value" @click="handleSelectedSort(sort.value)">
            <span :class="{ 'selected' : sort.value === selectedSort }">
              {{ sort.label }}
            </span>
          </li>
        </ul>
      </div>
    </template>
  </dropdown>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IMenuItemsOptionsItem } from '@/types/data-objects/items'
import { SortOptionValues } from '@/types'

/* API */

export default defineComponent({
  name: 'IfpFilterSort',

  props: {
    selectedSort: {
      type: String,
      required: true,
    },
    showSwitchToKanban: {
      type: Boolean,
      default: false,
    },
    showSwitchToList: {
      type: Boolean,
      default: false,
    },
    isKanban: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['settings', 'sort-updated', 'switch-to-kanban', 'switch-to-list'],

  computed: {
    sortOptions(): IMenuItemsOptionsItem[] {
      return [
        {
          label: 'Updated',
          value: SortOptionValues.UPDATED_RECENT,
        },
        {
          label: 'Updated Last',
          value: SortOptionValues.UPDATED_OLDEST,
        },
        {
          label: 'Created',
          value: SortOptionValues.CREATED_RECENT,
        },
        {
          label: 'Created Last',
          value: SortOptionValues.CREATED_OLDEST,
        },
        {
          label: 'Due Date',
          value: SortOptionValues.DUE_DATE,
        },
        {
          label: 'Title',
          value: SortOptionValues.TITLE,
        },
        {
          label: this.isKanban ? 'Custom' : 'Status',
          value: SortOptionValues.STATUS,
        },
        {
          label: 'Assignee',
          value: SortOptionValues.ASSIGNEE,
        },
        {
          label: 'Priority',
          value: SortOptionValues.PRIORITY,
        },
      ]
    },
    selectedSortLabel(): string {
      const selectedSort = this.sortOptions.find(
        sort => sort.value === this.selectedSort,
      )
      return selectedSort ? selectedSort.label : 'Select sort'
    },
  },

  methods: {
    handleSelectedSort(value: string) {
      this.$emit('sort-updated', value)
      // @ts-ignore
      this.$refs.dropdownRef.handleClose()
    },
    handleSwitchToKanban() {
      // @ts-ignore
      this.$refs.dropdownRef.handleClose()
      this.$emit('switch-to-kanban')
    },
    handleSwitchToList() {
      // @ts-ignore
      this.$refs.dropdownRef.handleClose()
      this.$emit('switch-to-list')
    },
    handleSettings() {
      // @ts-ignore
      this.$refs.dropdownRef.handleClose()
      this.$emit('settings')
    },
  },
})
</script>
<style lang="scss">
.ifp-filter-sort {
  /* Mobile only */
  .ddi-sort {
    color: var(--color-text-third);
    font-size: 20px;
  }

  &__section-header {
    font-size: 11px !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    color: var(--color-text-third) !important;
    letter-spacing: 0.05em !important;
    padding: 8px 16px 4px !important;
    cursor: default !important;

    &:hover {
      background-color: transparent !important;
    }
  }

  &__divider {
    height: 1px !important;
    padding: 0 !important;
    margin: 4px 0 !important;
    background-color: var(--color-background-third);
    cursor: default !important;

    &:hover {
      background-color: var(--color-background-third) !important;
    }
  }
}
</style>
